import { useState } from "react";
import { PageShell } from "../components/PageShell";
import { PageHero } from "../components/PageHero";
import { FAQS } from "../data/content";

export default function FAQPage() {
  const [open, setOpen] = useState(0);
  return (
    <PageShell>
      <PageHero
        eyebrow="Frequently Asked Questions"
        title="Everything you need to know,"
        italic="answered plainly"
        subtitle="Common questions from investors buying Dubai property from abroad."
      />

      <section className="py-16 md:py-24 px-6 md:px-12">
        <div className="max-w-3xl mx-auto space-y-3" data-testid="faq-list">
          {FAQS.map((f, i) => (
            <div key={i} className="glass rounded-xl overflow-hidden" data-testid={`faq-${i}`}>
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between text-left px-6 py-5 hover:bg-white/[0.02]"
              >
                <span className="font-serif-display text-lg md:text-xl pr-6">{f.q}</span>
                <span
                  className="w-8 h-8 rounded-full flex items-center justify-center shrink-0 text-lg transition-transform bg-[#c5a059]/20"
                  style={{ transform: open === i ? "rotate(45deg)" : "none" }}
                >
                  +
                </span>
              </button>
              {open === i && (
                <div className="px-6 pb-6 text-white/65 leading-relaxed">{f.a}</div>
              )}
            </div>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
